import { useLayoutEffect } from "preact/hooks"
import { useLocation } from "wouter-preact"

import { canonical_url_for_location_path } from "./canonical"

/** Keeps `<link rel="canonical">` and `og:url` aligned with the SPA path (fixes homepage canonical after client navigation). */
export function SyncCanonicalLink() {
  const [location] = useLocation()

  useLayoutEffect(() => {
    const href = canonical_url_for_location_path(location)

    let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null
    if (!link) {
      link = document.createElement("link")
      link.rel = "canonical"
      document.head.appendChild(link)
    }
    link.href = href

    const og_url = document.querySelector('meta[property="og:url"]') as HTMLMetaElement | null
    if (og_url) {
      og_url.setAttribute("content", href)
    }
  }, [location])

  return null
}
